<app-table-standard-layout 
  [dataSource$]="products$" 
  [title]="'Special Prices'" 
  [columnSettings]="columnSettings"
  [rowActionButtons]="rowActionButtons" 
  [topbarActionButton]="topbarActionButton">
</app-table-standard-layout>
